// this is an alternative to using webpack externals config that makes the external optional

import ContentApp from '@everfi/content-player';
export default ContentApp;
